export default __webpack_public_path__ + "static/media/red.01e993b5.png";